import React from "react";

export default function Hero({ title, subtitle, primaryLink, primaryText, secondaryLink, secondaryText, backgroundImage }) {
  const heroStyle = backgroundImage
    ? {
        backgroundImage: `linear-gradient(135deg, rgba(37, 99, 235, 0.85) 0%, rgba(13, 33, 55, 0.9) 100%), url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};

  return (
    <section className="hero blueprint-section-subtle" style={heroStyle}>
      <div className="container">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        {(primaryLink || secondaryLink) && (
          <div style={{ display: "flex", gap: "var(--space-md)", flexWrap: "wrap" }}>
            {primaryLink && (
              <a href={primaryLink} className="btn btn-primary">
                {primaryText || "Get Started"}
              </a>
            )}
            {secondaryLink && (
              <a href={secondaryLink} className="btn btn-outline">
                {secondaryText || "Learn More"}
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
}
